module.exports = __webpack_public_path__ + "static/media/20240320_095342.66bae973.jpg";